import { useState, useEffect } from "react";
import { Space } from "antd";
import { ButtonAdd } from "components/Common/Buttons";
import ButtonAction from "components/Common/ButtonAction";
import CustomAntdTable from "components/Common/CustomAntdTable";
import {
    CustomFormItemNumber,
    CustomFormItemSelectDropdown,
    CustomFormItemTextArea
} from "components/Common/CustomFormItem";
import useParamRepo from "services/repo/useParamRepo";
import useWBSRepo from "services/repo/useWBSRepo";


export default function SectionWbsTaskSubmission({ taskId, isView = false, form, initialTaskList = [], onChangeTaskList }) {

    const WBS_CAT_DEFAULT_UI = "-PILIH-";
    const [taskList, setTaskList] = useState([]);
    const { getParamByCategory } = useParamRepo(false);
    const { getWorkCalendarTimeUnit, getWBSTimeUnit } = useWBSRepo(false);

    const [outputUnitOptions, setOutputUnitOptions] = useState([]);
    const [frequencyOptions, setFrequencyOptions] = useState([]);
    const [routinNonRoutingOptions, setroutinNonRoutingOptions] = useState([]);
    const [timeUnitOptions, setTimeUnitOptions] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            const outputRes = await getParamByCategory({ paramCategory: "wbs_output_unit" });
            if (outputRes?.status === 200) {
                setOutputUnitOptions(outputRes.data.map(item => ({
                    label: item.paramValue,
                    value: item.paramId
                })));
            }

            const freqRes = await getParamByCategory({ paramCategory: "wbs_frequency_type" });
            if (freqRes?.status === 200) {
                setFrequencyOptions(freqRes.data.map(item => ({
                    label: item.paramValue,
                    value: item.paramId,
                    data: Number(item.paramData)
                })));
            }

            const routinNonRoutinRes = await getParamByCategory({ paramCategory: "wbs_category" });
            if (routinNonRoutinRes?.status === 200) {

                const opts = routinNonRoutinRes.data.map(item => ({
                    label: item.paramValue,
                    value: item.paramId
                }));

                // ⬅️ Inject opsi default "Pilih"
                setroutinNonRoutingOptions([
                    { label: "-PILIH-",  value: WBS_CAT_DEFAULT_UI },
                    ...opts
                ]);

                // setroutinNonRoutingOptions(routinNonRoutinRes.data.map(item => ({
                //     label: item.paramValue,
                //     value: item.paramId
                // })));
            }

            const timeUnitRes = await getWBSTimeUnit({ taskId });
            if (timeUnitRes?.status === 200) {
                setTimeUnitOptions(timeUnitRes.data.map(item => ({
                    label: item.wbsTuParamValue,
                    value: item.wbsTuId,
                    data: Number(item.wbsTuParamData)
                })));
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        //console.log("🧪 TaskList State after update:", taskList);
    }, [taskList]);

    const getData = (input) =>
        typeof input === 'object' && input !== null ? input.data : undefined;
    useEffect(() => {
        const updated = taskList.map(item => {
            const {
                timeToComplete,
                outputCount,
                outputTimeToCompleteUnit,
                frequency
            } = item;


            //console.log("Pening Wbs " + JSON.stringify(item))

            const timeUnitVal = item._timeUnitData ?? timeUnitOptions.find(opt => opt.value === outputTimeToCompleteUnit)?.data ?? 0;
            const frequencyVal = item._frequencyData ?? frequencyOptions.find(opt => opt.value === frequency)?.data ?? 0;
            const isReady = timeToComplete > 0 && outputCount > 0 && timeUnitVal > 0 && frequencyVal > 0;

            const fte = isReady ? calculateFTE({
                timeToComplete,
                outputTimeToCompleteUnit: timeUnitVal,
                outputCount,
                frequency: frequencyVal,
                wbsId: item.wbsId
            }) : 0;

            return {
                ...item,
                fte,
                personnel: fte
            };
        });

        setTaskList(updated);
        onChangeTaskList?.(updated);
    }, [taskList.length, timeUnitOptions, frequencyOptions]);

    const [hasInitialized, setHasInitialized] = useState(false);
    //const isOptionsReady = timeUnitOptions.length > 0 && frequencyOptions.length > 0;

    useEffect(() => {
        if (!hasInitialized && initialTaskList.length > 0) {

            const normalized = initialTaskList.map((item, index) => {
                const id = item.id || item.wbsContentId || `${Date.now()}-${index}`;

                const timeToComplete = Number(item.timeToComplete ?? item.wbsContentCompletionTime ?? 1);
                const outputCount = Number(item.outputCount ?? item.wbsContentWorkResult ?? 1);

                const outputTimeToCompleteUnit = item.outputTimeToCompleteUnit ?? item.wbsTuId;
                const frequency = item.frequency ?? item.wbsContentFrequencyTypeParamId;
                const outputUnit = item.outputUnit ?? item.wbsContentOutputUnitParamId;

                const rawWbsCatParamId = item.wbsCatParamId;

                // nilai untuk state
                const wbsCatParamId = rawWbsCatParamId && rawWbsCatParamId !== "" ? rawWbsCatParamId : null;


                const timeUnitData = getData(outputTimeToCompleteUnit);
                const frequencyData = getData(frequency);

                //console.log("✅ initialTaskList Wbs Id :", item.wbsId);

                const fte = (timeToComplete && timeUnitData && outputCount && frequencyData)
                    ? calculateFTE({
                        timeToComplete,
                        outputTimeToCompleteUnit: timeUnitData,
                        outputCount,
                        frequency: frequencyData,
                        wbsId: item.wbsId
                    }) : 0;

                return {
                    id,
                    wbsContentId: item.wbsContentId,
                    taskDescription: item.taskDescription ?? item.wbsContentTask ?? '',
                    remark: item.remark ?? item.wbsContentRemark ?? '',
                    outputUnit,
                    outputTimeToCompleteUnit,
                    frequency,
                    outputCount,
                    timeToComplete,
                    fte,
                    personnel: fte,
                    wbsId: item.wbsId,
                    _timeUnitData: timeUnitData,
                    _frequencyData: frequencyData,
                    wbsCatParamId,
                    isInitEditable: item.isInitEditable === true,
                    isNew: !(item.id || item.wbsContentId)
                };
            });

            setTaskList(normalized); // ⬅️ set ke state utama taskList
            onChangeTaskList?.(normalized);

            const formValues = {};
            normalized.forEach(row => {
                formValues[`taskDescription_${row.id}`] = row.taskDescription;
                formValues[`remark_${row.id}`] = row.remark;
                formValues[`outputUnit_${row.id}`] = row.outputUnit;
                formValues[`outputTimeToCompleteUnit_${row.id}`] = row.outputTimeToCompleteUnit;
                formValues[`frequency_${row.id}`] = row.frequency;
                formValues[`outputCount_${row.id}`] = row.outputCount;
                formValues[`wbsCatParamId_${row.id}`] = row.wbsCatParamId == null ? WBS_CAT_DEFAULT_UI : row.wbsCatParamId;
                formValues[`timeFinish_${row.id}`] = row.timeToComplete;
            });

            form.setFieldsValue(formValues);
            setHasInitialized(true);
        }
    }, [initialTaskList, timeUnitOptions, frequencyOptions, outputUnitOptions]);

    const parseNumber = (v) => {
        if (typeof v === "number") return v;
        if (v == null) return null;
        const s = String(v).replace(/,/g, "");
        const n = Number(s);
        return Number.isFinite(n) ? n : null;
    };


    const [effectiveHourYearlyTotal, setEffectiveHourYearlyTotal] = useState(null);
    // --- state: simpan hasil API ---
    const [effHourYear, setEffHourYear] = useState(null);          // "wbsWcEffectiveHourYearlyTotal"
    const [effMinuteYear, setEffMinuteYear] = useState(null);      // "wbsWcEffectiveMinuteYearlyTotal"
    const wbsIdFromList = initialTaskList?.[0]?.wbsId;

    useEffect(() => {
        if (!wbsIdFromList) return;
        (async () => {
            try {
                const res = await getWorkCalendarTimeUnit({ wbsId: wbsIdFromList });
                if (res?.status === 200) {
                    const wc = res.data.wbsWorkingCalendar;
                    const tu = res.data.wbsTimeUnitList || [];

                    // simpan nilai efektif dari API (jam & menit) — tidak ada rumus hardcode
                    const h = parseNumber(wc?.wbsWcEffectiveHourYearlyTotal);     // mis. 1489.2
                    const m = parseNumber(wc?.wbsWcEffectiveMinuteYearlyTotal);   // mis. 89352
                    if (h) setEffHourYear(h);
                    if (m) setEffMinuteYear(m);

                    // opsi satuan waktu 100% dari API (Menit=1, Jam=60, Hari=408, Minggu=2040) — tapi kita tidak mengasumsikan nilainya
                    if (tu.length) {
                        setTimeUnitOptions(
                            tu.map(x => ({
                                label: x.wbsTuParamValue,
                                value: x.wbsTuId,
                                data: parseNumber(x.wbsTuParamData) // pakai angka dari API
                            }))
                        );
                    }
                }
            } catch (e) {
                console.error("getWorkCalendarTimeUnit error:", e);
            }
        })();
    }, [wbsIdFromList]);

    const calculateFTE = ({ timeToComplete, outputTimeToCompleteUnit, outputCount, frequency }) => {
        const menitPerUnit = Number(outputTimeToCompleteUnit) || 0;

        const totalMenitPekerjaan =
            Number(timeToComplete) * menitPerUnit * Number(frequency) * Number(outputCount);

        // gunakan langsung nilai menit dari API
        const menitEfektifTahun =
            effMinuteYear && effMinuteYear > 0
                ? effMinuteYear
                : (effHourYear && effHourYear > 0 ? effHourYear * 60 : 0);

        if (!menitEfektifTahun) return 0;

        return totalMenitPekerjaan / menitEfektifTahun;
    };

    const onChangeInput = (id, field, value) => {
        setTaskList(prev => {
            const updatedList = prev.map(item => {
                if (item.id !== id) return item;


                let updated = { ...item };

                if (typeof value === 'object' && value !== null) {
                    updated[field] = value.value;

                    // Ambil ulang dari option jika value.data tidak tersedia
                    if (field === "outputTimeToCompleteUnit") {
                        const opt = timeUnitOptions.find(opt => opt.value === value.value);
                        updated._timeUnitData = opt?.data ?? 0;
                    }

                    if (field === "frequency") {
                        const opt = frequencyOptions.find(opt => opt.value === value.value);
                        updated._frequencyData = opt?.data ?? 0;
                    }
                }
                else {
                    updated[field] = value;
                }

                form.setFieldValue(`${field}_${id}`, value);

                const timeToComplete = updated.timeToComplete ?? 0;
                const outputCount = updated.outputCount ?? 0;

                const timeUnitVal =
                    updated._timeUnitData ??
                    timeUnitOptions.find(opt => opt.value === updated.outputTimeToCompleteUnit)?.data ?? 0;

                const frequencyVal =
                    updated._frequencyData ??
                    frequencyOptions.find(opt => opt.value === updated.frequency)?.data ?? 0;

                const isReady = timeToComplete > 0 && outputCount > 0 && timeUnitVal > 0 && frequencyVal > 0;

                console.log("🧪 Recalc FTE Check" + JSON.stringify(item))
                const fte = isReady
                    ? calculateFTE({
                        timeToComplete,
                        outputTimeToCompleteUnit: timeUnitVal,
                        outputCount,
                        frequency: frequencyVal,
                        wbsId: item.wbsId
                    })
                    : 0;

                updated.fte = fte;
                updated.personnel = fte;

                return updated;
            });

            // ⬇️ Kirim data terbaru ke parent
            onChangeTaskList?.(updatedList);
            return updatedList;
        });
    };


    const handleAddRow = () => {
            const newId = Date.now();   // ⬅️ definisikan dulu
        setTaskList(prev => [...prev, {
            id: Date.now(),
            taskDescription: "",
            outputUnit: "",
            timeToComplete: 0,
            outputTimeToCompleteUnit: "",
            frequency: "",
            outputCount: 0,
            fte: 0,
            personnel: 1,
            remark: "",
            wbsCatParamId: null,
            isInitEditable: true,
            isNew: true
        }]);
        form.setFieldValue(`wbsCatParamId_${newId}`, WBS_CAT_DEFAULT_UI);
    };

    const handleDeleteRow = (id) => {
        const updated = taskList.filter((item) => item.id !== id);
        setTaskList(updated);
        onChangeTaskList?.(updated);
    };

    const columns = [
        {
            title: "Action",
            key: "action",
            width: 50,
            render: (_, row) => (
                row.isNew ? (
                    <ButtonAction buttons={["delete"]} onDelete={() => handleDeleteRow(row.id)} />
                ) : null
            )
        },
        {
            title: "No",
            width: 50,
            render: (_, __, index) => index + 1
        },
        {
            title: "Uraian Tugas",
            dataIndex: "taskDescription",
            render: (_, row) => (
                <CustomFormItemTextArea
                    nameFormItem={`taskDescription_${row.id}`}
                    value={row.taskDescription}
                    wrapperCol={10}
                    labelCol={12}
                    styleInput={{
                        width: 450,
                        minHeight: 50,
                        maxHeight: 200,
                        overflow: 'hidden',
                        resize: 'none',
                        fontSize: 13,
                        lineHeight: 1.4,
                        padding: '8px 10px',
                    }}
                    autoSize={{ minRows: 2, maxRows: 8 }} // ✅ ini penting!
                    rows={3}
                    onChange={(e) => onChangeInput(row.id, "taskDescription", e.target.value)}
                    disabled={!row.isNew && !row.isInitEditable}
                    useInTable
                />
            )
        },
        {
            title: "Satuan Hasil",
            width: 120,
            dataIndex: "outputUnit",
            render: (_, row) => (
                <CustomFormItemSelectDropdown
                    nameFormItem={`outputUnit_${row.id}`}
                    value={row.outputUnit}
                    styleInput={{ width: 110 }}
                    options={outputUnitOptions}
                    onChange={(val) => onChangeInput(row.id, "outputUnit", val)}
                    useInTable
                />
            )
        },
        {
            title: "Waktu Penyelesaian",
            width: 120,
            dataIndex: "timeToComplete",
            render: (_, row) => (
                <CustomFormItemNumber
                    nameFormItem={`timeFinish_${row.id}`}
                    customvalue={row.timeToComplete}
                    min={0}
                    precision={0}
                    onChange={(val) => onChangeInput(row.id, "timeToComplete", val)}
                    initForm={form}
                    useInTable
                    styleInput={{ width: 120 }}
                />
            )
        },
        {
            title: "Satuan Waktu",
            width: 120,
            dataIndex: "outputTimeToCompleteUnit",
            render: (_, row) => (
                <CustomFormItemSelectDropdown
                    nameFormItem={`outputTimeToCompleteUnit_${row.id}`}
                    value={row.outputTimeToCompleteUnit}
                    styleInput={{ width: 100 }}
                    options={timeUnitOptions}
                    onChange={(value) => {
                        const option = timeUnitOptions.find(opt => opt.value === value);
                        onChangeInput(row.id, "outputTimeToCompleteUnit", {
                            value,
                            label: option?.label,
                            data: option?.data
                        });
                    }}
                    useInTable
                />
            )
        },
        {
            title: "Tipe Frekuensi",
            dataIndex: "frequency",
            width: 120,
            render: (_, row) => (
                <CustomFormItemSelectDropdown
                    nameFormItem={`frequency_${row.id}`}
                    value={row.frequency}
                    styleInput={{ width: 110 }}
                    options={frequencyOptions}
                    onChange={(value) => {
                        const option = frequencyOptions.find(opt => opt.value === value);
                        onChangeInput(row.id, "frequency", {
                            value,
                            label: option?.label,
                            data: option?.data
                        });
                    }}
                    useInTable
                />
            )
        },
        {
            title: "Hasil Kerja",
            width: 120,
            dataIndex: "outputCount",
            render: (_, row) => (
                <CustomFormItemNumber
                    nameFormItem={`outputCount_${row.id}`}
                    customvalue={row.outputCount}
                    min={0}
                    precision={0}
                    onChange={(val) => onChangeInput(row.id, "outputCount", val)}
                    initForm={form}
                    useInTable
                    styleInput={{ width: 120 }}
                />
            )
        },
        {
            title: "Tipe Kegiatan",
            dataIndex: "wbsCatParamId",
            width: 120,
            render: (_, row) => (
                <CustomFormItemSelectDropdown
                    nameFormItem={`wbsCatParamId_${row.id}`}
                      value={row.wbsCatParamId ?? WBS_CAT_DEFAULT_UI}
                    styleInput={{ width: 110 }}
                    options={routinNonRoutingOptions}
                    onChange={(value) => {
                       
                        const mappedValue = value === WBS_CAT_DEFAULT_UI ? null : value;

                        onChangeInput(row.id, "wbsCatParamId", mappedValue);
                        form.setFieldValue(`wbsCatParamId_${row.id}`, value);
                    }}
                    useInTable
                />
            )
        },
        {
            title: "Remarks",
            width: 250,
            dataIndex: "remark",
            render: (_, row) => (
                <CustomFormItemTextArea
                    nameFormItem={`remark_${row.id}`}
                    value={row.remark}
                    wrapperCol={10}
                    labelCol={12}
                    styleInput={{
                        width: 450,
                        minHeight: 50,
                        maxHeight: 200,
                        overflow: 'hidden',
                        resize: 'none',
                        fontSize: 13,
                        lineHeight: 1.4,
                        padding: '8px 10px',
                    }}
                    autoSize={{ minRows: 2, maxRows: 8 }} // ✅ ini penting!
                    rows={3} // masih aman untuk default
                    onChange={(e) => onChangeInput(row.id, "remark", e.target.value)}
                    useInTable
                />
            )
        }

    ];

    return (
        <div>
            <Space className="mb-2">
                <ButtonAdd onClick={handleAddRow} buttonText="Add Uraian Tugas" />
            </Space>
            <CustomAntdTable
                columns={columns}
                dataSource={taskList}
                rowKey="id"
                pagination={false}
            />
        </div>
    );
}
